export enum TraitementFicheImplantation_Statut {
    EnAttenteDeTraitement,
    EnCoursDeTraitement,
    Traite
}

export function TraitementFicheImplantation_Statut_ToText(input: TraitementFicheImplantation_Statut) {
    switch (input) {
        case TraitementFicheImplantation_Statut.EnAttenteDeTraitement:
            return 'Nouveau'
        case TraitementFicheImplantation_Statut.EnCoursDeTraitement:
            return 'En cours de traitement'
        case TraitementFicheImplantation_Statut.Traite:
            return 'Traité'
    }
}
